<template>
  <div class="background">
    <img src="~@/assets/img/jrcs-bj.png" class="nrbj"/>

    <!--智能客服-->
    <CustomerService/>

    <!--在线留言-->
    <OnlineMsg/>

    <div class="nrBox">
      <img src="~@/assets/img/jrcs.png" class="jsbanner"/>

      <div class="nrMain">
        <!--结果统计-->
        <div class="resultTotal">
          <p>
            <a-icon type="switcher" />
            根据您的需求，一共为您找到<span>{{productList.length}}</span>件转贷产品
          </p>
        </div>

        <!--结果列表-->
        <div class="result">
<!--          <a-spin :spinning="spinning" tip="搜索中...."></a-spin>-->
          <a-list item-layout="vertical" size="large" :data-source="productList" :pagination="pagination" >
            <a-list-item class="pro_bg"
                         slot="renderItem" key="item.id" slot-scope="item" @click="listClick(item.id)">
              <div class="proImg">
                <img :src="downPath+'1642819511wc.png'"  height="30px">
              </div>
              <div class="proName">
                <div style="font-size: 20px;font-weight: 600;margin-bottom: 5px;">
                  {{item.productName}}
                </div>
<!--                <div>-->
<!--                  适用对象：{{item.type}}-->
<!--                </div>-->
              </div>
              <div class="proList">
                <div class="proRate">
                  <div class="proNum" style="color: #1492ff">
                    {{ item.interestRate }}
                  </div>
                  <div class="proList">
                    <img src="~@/assets/img/hz33.png">
                    <span>资金使用费</span>
                  </div>
                </div>
                <div class="proDeadLine">
                  <div class="proNum" style="color: #fa8c16">
                    {{item.startTime}}-{{item.endTime}}（天）
                  </div>
                  <div class="proList">
                    <img src="~@/assets/img/hz34.png">
                    <span>转贷期限</span>
                  </div>
                </div>
                <div class="proAmount">
                  <div class="proNum" style="color: #4AC3BF">
                    {{item.minAmount}}-{{item.maxAmount}}（万元）
                  </div>
                  <div class="proList">
                    <img src="~@/assets/img/hz35.png">
                    <span>转贷金额</span>

                  </div>
                </div>
              </div>
            </a-list-item>
          </a-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {getAll} from "@/api/zdcp/zdcp";
import {mapState} from "vuex";
export default {
  computed: {
    ...mapState(["downPath"]),
  },
  data() {
    return {
      productList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        onChange: page => {
          this.pageChange(page);
        },
      },
    }
  },
  computed: {
    ...mapState(["downPath"]),
  },
  beforeRouteEnter(to, from, next) {
    getAll()
        .then(res => {
          next(vm => {
            if (res.data.success === "TRUE") {
              vm.productList = res.data.data.result;
              for(let i=0; i<vm.productList.length; i++) {
                let t = vm.productList[i].interestRate.split('（')[0];
                vm.productList[i].interestRate = t;
              }
              // vm.pagination = {
              //   current: res.data.data.result.pageNum,
              //   pageSize: res.data.data.result.pageSize,
              //   total: res.data.data.result.total
              // };
            }
          });
        })
        .catch(() => {
          next(vm => {
            vm.$message.error("服务器出错！请稍后再试!");
            vm.$Progress.fail();
          });
        });
  },

  methods: {
    //换页
    pageChange(page) {
      this.pagination.current = page;
    },
    listClick(id){
      //this.$router.push({ name: "financeProduct_detail", query: {id: id} });
      const {href} = this.$router.resolve({
        name: "zdcpShop_detail", query: {id: id}
      });
      window.open(href, '_blank');
    },
  }
}
</script>

<style scoped lang="less">
.background{
  width: 100%;
  background-color: #f5f5f5;
  position: relative;
  z-index: 1;
  margin: 102px 0 20px 0;
}
.nrbj{
  width: 100%;
  height: 360px;
  position: absolute;
  z-index: 3;
  top: 0;
}

.nrBox{
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 5;
  padding-top: 50px;
}

.jsbanner{
  display: block;
  width: 684px;
  margin: 0 auto;
  margin-bottom: 30px;
}

.nrMain{
  width: 100%;
  background-color: #ffffff;
  padding: 20px;
  margin-bottom: 20px;
}

.search{
  width: 100%;
  min-height: 300px;
}

.search-form .ant-form-item{
  font-weight: bold;
  width: 100%;
  border-bottom: solid 1px WhiteSmoke;
  padding: 5px 0;
  margin-bottom: 20px;
}
.search-form .ant-form-item:nth-child(1){
  border-bottom: 0;
}
/deep/ .search .ant-form label{
  font-size: 16px;
}

.condition2 {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
}

.resultTotal{
  width: 100%;
  height: 40px;
  background-color: rgba(20,146,255,0.05);
  border: solid 1px #1492ff;
  border-radius: 5px;
  padding: 0 10px;
  margin-bottom: 30px;

  p{
    font-size: 14px;
    line-height: 40px;

    i{
      font-size: 16px;
      color: #1492ff;
    }

    span{
      color: #1492ff;
      font-family: 'DIN_Condensed_Bold';
      font-size: 16px;
      margin: 0 5px;
    }
  }
}

.result{
  width: 100%;

  /deep/ .ant-list-items{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}

.pro_bg{
  width: 49%;
  border: solid 1px #eeeeee;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
.dd5{
  height: 99px;
  width: 100%;
  background: #383d41;margin:0 auto;
}
.dd5_copyright{
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding-top:40px;
}


.font1 {
  font-size: small;
  font-weight: bolder;
  color: #3bb6f7;
}

.font2 {
  font-size: x-large;
  font-weight: bolder;
}

.proImg {
  width: 100%;
  margin-bottom: 20px;
}

.proName {
  width: 100%;
  color: #333333;
  line-height: 30px;
  margin-bottom: 20px;
}

.proList{
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}

.proRate {
  width: 33.3%;
}

.proDeadLine {
  width: 33.3%;
}

.proAmount {
  width: 33.3%;
}

.proList{
  color: #333333;
  font-size: 14px;
  margin-top: 10px;

  img{
    float: left;
    margin: 3px 5px 0 0;
  }
}

.proNum{
  font-family: 'DIN_Condensed_Bold';
  font-size: 20px;
}

</style>